import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store';
import { selectArmsSorted } from '@/store/selectors';
import { CollapsibleSection } from '@/components/ui/CollapsibleSection';
import { Button } from '@/components/ui/Button';
import { ArmFields } from './ArmFields';

/** Collapsible section 1 — Arm Configuration (P1.5.3). */
export function ArmConfiguration() {
  const arms = useStore(useShallow(selectArmsSorted));
  const swapRoles = useStore((s) => s.swapRoles);

  return (
    <CollapsibleSection sectionKey="calculator.armConfig" title="Arm Configuration" column="left" actions={<Button size="sm" variant="ghost" onClick={swapRoles}>Swap roles</Button>}>
      <div className="arm-config-grid">
        {arms.map((arm) => (
          <ArmFields key={arm.id} arm={arm} />
        ))}
      </div>
    </CollapsibleSection>
  );
}
